import S, { useRef as I, useCallback as N, useState as G, useContext as W, useEffect as _, createContext as X, useMemo as ie, forwardRef as we } from "react";
import Fn, { flushSync as zt } from "react-dom";
function Bt(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Bt(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function On() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Bt(e)) && (r && (r += " "), r += t);
  return r;
}
const q = typeof document < "u" ? S.useLayoutEffect : () => {
};
function re(e) {
  const t = I(null);
  return q(() => {
    t.current = e;
  }, [
    e
  ]), N((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const ke = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Ut = /* @__PURE__ */ S.createContext(ke), Mn = /* @__PURE__ */ S.createContext(!1);
let Dn = !!(typeof window < "u" && window.document && window.document.createElement), Be = /* @__PURE__ */ new WeakMap();
function In(e = !1) {
  let t = W(Ut), n = I(null);
  if (n.current === null && !e) {
    var r, o;
    let i = (o = S.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || o === void 0 || (r = o.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let l = Be.get(i);
      l == null ? Be.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== l.state && (t.current = l.id, Be.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function kn(e) {
  let t = W(Ut);
  t === ke && !Dn && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = In(!!e), r = t === ke && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Hn(e) {
  let t = S.useId(), [n] = G(lt()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ke.prefix}`;
  return e || `${r}-${t}`;
}
const An = typeof S.useId == "function" ? Hn : kn;
function Nn() {
  return !1;
}
function Rn() {
  return !0;
}
function Kn(e) {
  return () => {
  };
}
function lt() {
  return typeof S.useSyncExternalStore == "function" ? S.useSyncExternalStore(Kn, Nn, Rn) : W(Mn);
}
let _n = !!(typeof window < "u" && window.document && window.document.createElement), de = /* @__PURE__ */ new Map(), he;
typeof FinalizationRegistry < "u" && (he = new FinalizationRegistry((e) => {
  de.delete(e);
}));
function pe(e) {
  let [t, n] = G(e), r = I(null), o = An(t), i = I(null);
  if (he && he.register(i, o), _n) {
    const l = de.get(o);
    l && !l.includes(r) ? l.push(r) : de.set(o, [
      r
    ]);
  }
  return q(() => {
    let l = o;
    return () => {
      he && he.unregister(i), de.delete(l);
    };
  }, [
    o
  ]), _(() => {
    let l = r.current;
    return l && n(l), () => {
      l && (r.current = null);
    };
  }), o;
}
function Vn(e, t) {
  if (e === t) return e;
  let n = de.get(e);
  if (n)
    return n.forEach((o) => o.current = t), t;
  let r = de.get(t);
  return r ? (r.forEach((o) => o.current = e), e) : t;
}
function at(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const z = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Z = (e) => e && "window" in e && e.window === e ? e : z(e).defaultView || window;
function zn(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function Bn(e) {
  return zn(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let Un = !1;
function st() {
  return Un;
}
function k(e, t) {
  if (!st()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : Bn(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Ee = (e = document) => {
  var t;
  if (!st()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function M(e) {
  return st() && e.target.shadowRoot && e.composedPath ? e.composedPath()[0] : e.target;
}
function V(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let o in r) {
      let i = t[o], l = r[o];
      typeof i == "function" && typeof l == "function" && // This is a lot faster than a regex.
      o[0] === "o" && o[1] === "n" && o.charCodeAt(2) >= /* 'A' */
      65 && o.charCodeAt(2) <= /* 'Z' */
      90 ? t[o] = at(i, l) : (o === "className" || o === "UNSAFE_className") && typeof i == "string" && typeof l == "string" ? t[o] = On(i, l) : o === "id" && i && l ? t.id = Vn(i, l) : t[o] = l !== void 0 ? l : i;
    }
  }
  return t;
}
function Wn(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = ht(o, t);
      return n || (n = typeof i == "function"), i;
    });
    if (n) return () => {
      r.forEach((o, i) => {
        typeof o == "function" ? o() : ht(e[i], null);
      });
    };
  };
}
function ht(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
const jn = /* @__PURE__ */ new Set([
  "id"
]), Gn = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Yn = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Xn = /^(data-.*)$/;
function xe(e, t = {}) {
  let { labelable: n, isLink: r, propNames: o } = t, i = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (jn.has(l) || n && Gn.has(l) || r && Yn.has(l) || o != null && o.has(l) || Xn.test(l)) && (i[l] = e[l]);
  return i;
}
function ve(e) {
  if (Zn()) e.focus({
    preventScroll: !0
  });
  else {
    let t = qn(e);
    e.focus(), Jn(t);
  }
}
let Fe = null;
function Zn() {
  if (Fe == null) {
    Fe = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Fe = !0, !0;
        }
      });
    } catch {
    }
  }
  return Fe;
}
function qn(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function Jn(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function _e(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function ct(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function te(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const be = te(function() {
  return ct(/^Mac/i);
}), Qn = te(function() {
  return ct(/^iPhone/i);
}), Wt = te(function() {
  return ct(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  be() && navigator.maxTouchPoints > 1;
}), ut = te(function() {
  return Qn() || Wt();
});
te(function() {
  return be() || ut();
});
const jt = te(function() {
  return _e(/AppleWebKit/i) && !er();
}), er = te(function() {
  return _e(/Chrome/i);
}), Gt = te(function() {
  return _e(/Android/i);
}), tr = te(function() {
  return _e(/Firefox/i);
}), nr = /* @__PURE__ */ X({
  isNative: !0,
  open: ir,
  useHref: (e) => e
});
function Yt() {
  return W(nr);
}
function rr(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function $e(e, t, n = !0) {
  var r, o;
  let { metaKey: i, ctrlKey: l, altKey: a, shiftKey: u } = t;
  tr() && (!((o = window.event) === null || o === void 0 || (r = o.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (be() ? i = !0 : l = !0);
  let d = jt() && be() && !Wt() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: l,
    altKey: a,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: l,
    altKey: a,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  $e.isOpening = n, ve(e), e.dispatchEvent(d), $e.isOpening = !1;
}
$e.isOpening = !1;
function or(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function ir(e, t) {
  or(e, (n) => $e(n, t));
}
function lr(e) {
  let t = Yt();
  var n;
  const r = t.useHref((n = e == null ? void 0 : e.href) !== null && n !== void 0 ? n : "");
  return {
    href: e != null && e.href ? r : void 0,
    target: e == null ? void 0 : e.target,
    rel: e == null ? void 0 : e.rel,
    download: e == null ? void 0 : e.download,
    ping: e == null ? void 0 : e.ping,
    referrerPolicy: e == null ? void 0 : e.referrerPolicy
  };
}
let oe = /* @__PURE__ */ new Map(), Xe = /* @__PURE__ */ new Set();
function yt() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let o = oe.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), oe.set(r.target, o), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let o = oe.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", n), oe.delete(r.target)), oe.size === 0)) {
      for (let i of Xe) i();
      Xe.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? yt() : document.addEventListener("DOMContentLoaded", yt));
function ar() {
  for (const [e] of oe)
    "isConnected" in e && !e.isConnected && oe.delete(e);
}
function Xt(e) {
  requestAnimationFrame(() => {
    ar(), oe.size === 0 ? e() : Xe.add(e);
  });
}
function dt() {
  let e = I(/* @__PURE__ */ new Map()), t = N((o, i, l, a) => {
    let u = a != null && a.once ? (...d) => {
      e.current.delete(l), l(...d);
    } : l;
    e.current.set(l, {
      type: i,
      eventTarget: o,
      fn: u,
      options: a
    }), o.addEventListener(i, u, a);
  }, []), n = N((o, i, l, a) => {
    var u;
    let d = ((u = e.current.get(l)) === null || u === void 0 ? void 0 : u.fn) || l;
    o.removeEventListener(i, d, a), e.current.delete(l);
  }, []), r = N(() => {
    e.current.forEach((o, i) => {
      n(o.eventTarget, o.type, i, o.options);
    });
  }, [
    n
  ]);
  return _(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function sr(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": o } = e;
  return n = pe(n), o && r ? o = [
    .../* @__PURE__ */ new Set([
      n,
      ...o.trim().split(/\s+/)
    ])
  ].join(" ") : o && (o = o.trim().split(/\s+/).join(" ")), !r && !o && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": o
  };
}
function Zt(e) {
  const t = I(null), n = I(void 0), r = N((o) => {
    if (typeof e == "function") {
      const i = e, l = i(o);
      return () => {
        typeof l == "function" ? l() : i(null);
      };
    } else if (e)
      return e.current = o, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return ie(() => ({
    get current() {
      return t.current;
    },
    set current(o) {
      t.current = o, n.current && (n.current(), n.current = void 0), o != null && (n.current = r(o));
    }
  }), [
    r
  ]);
}
function cr() {
  return typeof window.ResizeObserver < "u";
}
function Pt(e) {
  const { ref: t, box: n, onResize: r } = e;
  _(() => {
    let o = t == null ? void 0 : t.current;
    if (o)
      if (cr()) {
        const i = new window.ResizeObserver((l) => {
          l.length && r();
        });
        return i.observe(o, {
          box: n
        }), () => {
          o && i.unobserve(o);
        };
      } else
        return window.addEventListener("resize", r, !1), () => {
          window.removeEventListener("resize", r, !1);
        };
  }, [
    r,
    t,
    n
  ]);
}
function qt(e, t) {
  q(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Ze(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Gt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function ur(e) {
  return !Gt() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function dr(e, t = !0) {
  let [n, r] = G(!0), o = n && t;
  return q(() => {
    if (o && e.current && "getAnimations" in e.current)
      for (let i of e.current.getAnimations()) i instanceof CSSTransition && i.cancel();
  }, [
    e,
    o
  ]), Jt(e, o, N(() => r(!1), [])), o;
}
function fr(e, t) {
  let [n, r] = G(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let o = n === "exiting";
  return Jt(e, o, N(() => {
    r((i) => i === "exiting" ? "closed" : i);
  }, [])), o;
}
function Jt(e, t, n) {
  q(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let o = !1;
      return Promise.all(r.map((i) => i.finished)).then(() => {
        o || zt(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        o = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Qt = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], pr = Qt.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Qt.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
function vr(e) {
  return e.matches(pr);
}
function en(e, t, n) {
  let [r, o] = G(e || t), i = I(e !== void 0), l = e !== void 0;
  _(() => {
    let d = i.current;
    d !== l && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${d ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}.`), i.current = l;
  }, [
    l
  ]);
  let a = l ? e : r, u = N((d, ...f) => {
    let p = (g, ...b) => {
      n && (Object.is(a, g) || n(g, ...b)), l || (a = g);
    };
    typeof d == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), o((b, ...m) => {
      let $ = d(l ? a : b, ...m);
      return p($, ...f), l ? b : $;
    })) : (l || o(d), p(d, ...f));
  }, [
    l,
    a,
    n
  ]);
  return [
    a,
    u
  ];
}
function Te(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const br = Symbol("default");
function $r({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ S.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Se(e) {
  let { className: t, style: n, children: r, defaultClassName: o, defaultChildren: i, defaultStyle: l, values: a } = e;
  return ie(() => {
    let u, d, f;
    return typeof t == "function" ? u = t({
      ...a,
      defaultClassName: o
    }) : u = t, typeof n == "function" ? d = n({
      ...a,
      defaultStyle: l || {}
    }) : d = n, typeof r == "function" ? f = r({
      ...a,
      defaultChildren: i
    }) : r == null ? f = i : f = r, {
      className: u ?? o,
      style: d || l ? {
        ...l,
        ...d
      } : void 0,
      children: f ?? i,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    o,
    i,
    l,
    a
  ]);
}
function gr(e, t) {
  let n = W(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || br;
    if (!n.slots[r]) {
      let o = new Intl.ListFormat().format(Object.keys(n.slots).map((l) => `"${l}"`)), i = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${i} Valid slot names are ${o}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Le(e, t, n) {
  let r = gr(n, e.slot) || {}, { ref: o, ...i } = r, l = Zt(ie(() => Wn(t, o), [
    t,
    o
  ])), a = V(i, e);
  return "style" in i && i.style && "style" in e && e.style && (typeof i.style == "function" || typeof e.style == "function" ? a.style = (u) => {
    let d = typeof i.style == "function" ? i.style(u) : i.style, f = {
      ...u.defaultStyle,
      ...d
    }, p = typeof e.style == "function" ? e.style({
      ...u,
      defaultStyle: f
    }) : e.style;
    return {
      ...f,
      ...p
    };
  } : a.style = {
    ...i.style,
    ...e.style
  }), [
    a,
    l
  ];
}
function mr(e = !0) {
  let [t, n] = G(e), r = I(!1), o = N((i) => {
    r.current = !0, n(!!i);
  }, []);
  return q(() => {
    r.current || n(!1);
  }, []), [
    o,
    t
  ];
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const hr = /* @__PURE__ */ X(!1);
function yr(e) {
  let t = (n, r) => W(hr) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, we(t);
}
function ft(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function tn(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function nn(e) {
  let t = I({
    isFocused: !1,
    observer: null
  });
  q(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = re((r) => {
    e == null || e(r);
  });
  return N((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = r.target, i = (l) => {
        if (t.current.isFocused = !1, o.disabled) {
          let a = ft(l);
          n(a);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var l;
          (l = t.current.observer) === null || l === void 0 || l.disconnect();
          let a = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let He = !1;
function Et(e) {
  for (; e && !vr(e); ) e = e.parentElement;
  let t = Z(e), n = t.document.activeElement;
  if (!n || n === e) return;
  He = !0;
  let r = !1, o = (f) => {
    (f.target === n || r) && f.stopImmediatePropagation();
  }, i = (f) => {
    (f.target === n || r) && (f.stopImmediatePropagation(), !e && !r && (r = !0, ve(n), u()));
  }, l = (f) => {
    (f.target === e || r) && f.stopImmediatePropagation();
  }, a = (f) => {
    (f.target === e || r) && (f.stopImmediatePropagation(), r || (r = !0, ve(n), u()));
  };
  t.addEventListener("blur", o, !0), t.addEventListener("focusout", i, !0), t.addEventListener("focusin", a, !0), t.addEventListener("focus", l, !0);
  let u = () => {
    cancelAnimationFrame(d), t.removeEventListener("blur", o, !0), t.removeEventListener("focusout", i, !0), t.removeEventListener("focusin", a, !0), t.removeEventListener("focus", l, !0), He = !1, r = !1;
  }, d = requestAnimationFrame(u);
  return u;
}
let ue = "default", qe = "", Ie = /* @__PURE__ */ new WeakMap();
function Tt(e) {
  if (ut()) {
    if (ue === "default") {
      const t = z(e);
      qe = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    ue = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Ie.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Ue(e) {
  if (ut()) {
    if (ue !== "disabled") return;
    ue = "restoring", setTimeout(() => {
      Xt(() => {
        if (ue === "restoring") {
          const t = z(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = qe || ""), qe = "", ue = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Ie.has(e)) {
    let t = Ie.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Ie.delete(e);
  }
}
const rn = S.createContext({
  register: () => {
  }
});
rn.displayName = "PressResponderContext";
function Pr(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function on(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function Er(e, t) {
  var n = on(e, t, "get");
  return Pr(e, n);
}
function Tr(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function wr(e, t, n) {
  Tr(e, t), t.set(e, n);
}
function xr(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function wt(e, t, n) {
  var r = on(e, t, "set");
  return xr(e, r, n), n;
}
function Sr(e) {
  let t = W(rn);
  if (t) {
    let { register: n, ...r } = t;
    e = V(r, e), n();
  }
  return qt(t, e.ref), e;
}
var Oe = /* @__PURE__ */ new WeakMap();
class Me {
  continuePropagation() {
    wt(this, Oe, !1);
  }
  get shouldStopPropagation() {
    return Er(this, Oe);
  }
  constructor(t, n, r, o) {
    wr(this, Oe, {
      writable: !0,
      value: void 0
    }), wt(this, Oe, !0);
    var i;
    let l = (i = o == null ? void 0 : o.target) !== null && i !== void 0 ? i : r.currentTarget;
    const a = l == null ? void 0 : l.getBoundingClientRect();
    let u, d = 0, f, p = null;
    r.clientX != null && r.clientY != null && (f = r.clientX, p = r.clientY), a && (f != null && p != null ? (u = f - a.left, d = p - a.top) : (u = a.width / 2, d = a.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = u, this.y = d;
  }
}
const xt = Symbol("linkClicked"), St = "react-aria-pressable-style", Lt = "data-react-aria-pressable";
function ln(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: o, onPressUp: i, onClick: l, isDisabled: a, isPressed: u, preventFocusOnPress: d, shouldCancelOnPointerExit: f, allowTextSelectionOnPress: p, ref: g, ...b } = Sr(e), [m, $] = G(!1), y = I({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: h, removeAllGlobalListeners: E } = dt(), L = re((s, P) => {
    let F = y.current;
    if (a || F.didFirePressStart) return !1;
    let v = !0;
    if (F.isTriggeringEvent = !0, r) {
      let C = new Me("pressstart", P, s);
      r(C), v = C.shouldStopPropagation;
    }
    return n && n(!0), F.isTriggeringEvent = !1, F.didFirePressStart = !0, $(!0), v;
  }), O = re((s, P, F = !0) => {
    let v = y.current;
    if (!v.didFirePressStart) return !1;
    v.didFirePressStart = !1, v.isTriggeringEvent = !0;
    let C = !0;
    if (o) {
      let c = new Me("pressend", P, s);
      o(c), C = c.shouldStopPropagation;
    }
    if (n && n(!1), $(!1), t && F && !a) {
      let c = new Me("press", P, s);
      t(c), C && (C = c.shouldStopPropagation);
    }
    return v.isTriggeringEvent = !1, C;
  }), D = re((s, P) => {
    let F = y.current;
    if (a) return !1;
    if (i) {
      F.isTriggeringEvent = !0;
      let v = new Me("pressup", P, s);
      return i(v), F.isTriggeringEvent = !1, v.shouldStopPropagation;
    }
    return !0;
  }), x = re((s) => {
    let P = y.current;
    if (P.isPressed && P.target) {
      P.didFirePressStart && P.pointerType != null && O(ce(P.target, s), P.pointerType, !1), P.isPressed = !1, P.isOverTarget = !1, P.activePointerId = null, P.pointerType = null, E(), p || Ue(P.target);
      for (let F of P.disposables) F();
      P.disposables = [];
    }
  }), B = re((s) => {
    f && x(s);
  }), j = re((s) => {
    l == null || l(s);
  }), U = re((s, P) => {
    if (l) {
      let F = new MouseEvent("click", s);
      tn(F, P), l(ft(F));
    }
  }), H = ie(() => {
    let s = y.current, P = {
      onKeyDown(v) {
        if (We(v.nativeEvent, v.currentTarget) && k(v.currentTarget, M(v.nativeEvent))) {
          var C;
          Ot(M(v.nativeEvent), v.key) && v.preventDefault();
          let c = !0;
          if (!s.isPressed && !v.repeat) {
            s.target = v.currentTarget, s.isPressed = !0, s.pointerType = "keyboard", c = L(v, "keyboard");
            let T = v.currentTarget, w = (K) => {
              We(K, T) && !K.repeat && k(T, M(K)) && s.target && D(ce(s.target, K), "keyboard");
            };
            h(z(v.currentTarget), "keyup", at(w, F), !0);
          }
          c && v.stopPropagation(), v.metaKey && be() && ((C = s.metaKeyEvents) === null || C === void 0 || C.set(v.key, v.nativeEvent));
        } else v.key === "Meta" && (s.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(v) {
        if (!(v && !k(v.currentTarget, M(v.nativeEvent))) && v && v.button === 0 && !s.isTriggeringEvent && !$e.isOpening) {
          let C = !0;
          if (a && v.preventDefault(), !s.ignoreEmulatedMouseEvents && !s.isPressed && (s.pointerType === "virtual" || Ze(v.nativeEvent))) {
            let c = L(v, "virtual"), T = D(v, "virtual"), w = O(v, "virtual");
            j(v), C = c && T && w;
          } else if (s.isPressed && s.pointerType !== "keyboard") {
            let c = s.pointerType || v.nativeEvent.pointerType || "virtual";
            C = O(ce(v.currentTarget, v), c, !0), s.isOverTarget = !1, j(v), x(v);
          }
          s.ignoreEmulatedMouseEvents = !1, C && v.stopPropagation();
        }
      }
    }, F = (v) => {
      var C;
      if (s.isPressed && s.target && We(v, s.target)) {
        var c;
        Ot(M(v), v.key) && v.preventDefault();
        let w = M(v), K = k(s.target, M(v));
        O(ce(s.target, v), "keyboard", K), K && U(v, s.target), E(), v.key !== "Enter" && pt(s.target) && k(s.target, w) && !v[xt] && (v[xt] = !0, $e(s.target, v, !1)), s.isPressed = !1, (c = s.metaKeyEvents) === null || c === void 0 || c.delete(v.key);
      } else if (v.key === "Meta" && (!((C = s.metaKeyEvents) === null || C === void 0) && C.size)) {
        var T;
        let w = s.metaKeyEvents;
        s.metaKeyEvents = void 0;
        for (let K of w.values()) (T = s.target) === null || T === void 0 || T.dispatchEvent(new KeyboardEvent("keyup", K));
      }
    };
    if (typeof PointerEvent < "u") {
      P.onPointerDown = (c) => {
        if (c.button !== 0 || !k(c.currentTarget, M(c.nativeEvent))) return;
        if (ur(c.nativeEvent)) {
          s.pointerType = "virtual";
          return;
        }
        s.pointerType = c.pointerType;
        let T = !0;
        if (!s.isPressed) {
          s.isPressed = !0, s.isOverTarget = !0, s.activePointerId = c.pointerId, s.target = c.currentTarget, p || Tt(s.target), T = L(c, s.pointerType);
          let w = M(c.nativeEvent);
          "releasePointerCapture" in w && w.releasePointerCapture(c.pointerId), h(z(c.currentTarget), "pointerup", v, !1), h(z(c.currentTarget), "pointercancel", C, !1);
        }
        T && c.stopPropagation();
      }, P.onMouseDown = (c) => {
        if (k(c.currentTarget, M(c.nativeEvent)) && c.button === 0) {
          if (d) {
            let T = Et(c.target);
            T && s.disposables.push(T);
          }
          c.stopPropagation();
        }
      }, P.onPointerUp = (c) => {
        !k(c.currentTarget, M(c.nativeEvent)) || s.pointerType === "virtual" || c.button === 0 && D(c, s.pointerType || c.pointerType);
      }, P.onPointerEnter = (c) => {
        c.pointerId === s.activePointerId && s.target && !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, L(ce(s.target, c), s.pointerType));
      }, P.onPointerLeave = (c) => {
        c.pointerId === s.activePointerId && s.target && s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, O(ce(s.target, c), s.pointerType, !1), B(c));
      };
      let v = (c) => {
        if (c.pointerId === s.activePointerId && s.isPressed && c.button === 0 && s.target) {
          if (k(s.target, M(c)) && s.pointerType != null) {
            let T = !1, w = setTimeout(() => {
              s.isPressed && s.target instanceof HTMLElement && (T ? x(c) : (ve(s.target), s.target.click()));
            }, 80);
            h(c.currentTarget, "click", () => T = !0, !0), s.disposables.push(() => clearTimeout(w));
          } else x(c);
          s.isOverTarget = !1;
        }
      }, C = (c) => {
        x(c);
      };
      P.onDragStart = (c) => {
        k(c.currentTarget, M(c.nativeEvent)) && x(c);
      };
    } else if (process.env.NODE_ENV === "test") {
      P.onMouseDown = (c) => {
        if (c.button !== 0 || !k(c.currentTarget, M(c.nativeEvent))) return;
        if (s.ignoreEmulatedMouseEvents) {
          c.stopPropagation();
          return;
        }
        if (s.isPressed = !0, s.isOverTarget = !0, s.target = c.currentTarget, s.pointerType = Ze(c.nativeEvent) ? "virtual" : "mouse", zt(() => L(c, s.pointerType)) && c.stopPropagation(), d) {
          let w = Et(c.target);
          w && s.disposables.push(w);
        }
        h(z(c.currentTarget), "mouseup", v, !1);
      }, P.onMouseEnter = (c) => {
        if (!k(c.currentTarget, M(c.nativeEvent))) return;
        let T = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !0, T = L(c, s.pointerType)), T && c.stopPropagation();
      }, P.onMouseLeave = (c) => {
        if (!k(c.currentTarget, M(c.nativeEvent))) return;
        let T = !0;
        s.isPressed && !s.ignoreEmulatedMouseEvents && s.pointerType != null && (s.isOverTarget = !1, T = O(c, s.pointerType, !1), B(c)), T && c.stopPropagation();
      }, P.onMouseUp = (c) => {
        k(c.currentTarget, M(c.nativeEvent)) && !s.ignoreEmulatedMouseEvents && c.button === 0 && D(c, s.pointerType || "mouse");
      };
      let v = (c) => {
        if (c.button === 0) {
          if (s.ignoreEmulatedMouseEvents) {
            s.ignoreEmulatedMouseEvents = !1;
            return;
          }
          s.target && s.target.contains(c.target) && s.pointerType != null || x(c), s.isOverTarget = !1;
        }
      };
      P.onTouchStart = (c) => {
        if (!k(c.currentTarget, M(c.nativeEvent))) return;
        let T = Lr(c.nativeEvent);
        if (!T) return;
        s.activePointerId = T.identifier, s.ignoreEmulatedMouseEvents = !0, s.isOverTarget = !0, s.isPressed = !0, s.target = c.currentTarget, s.pointerType = "touch", p || Tt(s.target), L(ne(s.target, c), s.pointerType) && c.stopPropagation(), h(Z(c.currentTarget), "scroll", C, !0);
      }, P.onTouchMove = (c) => {
        if (!k(c.currentTarget, M(c.nativeEvent))) return;
        if (!s.isPressed) {
          c.stopPropagation();
          return;
        }
        let T = Ct(c.nativeEvent, s.activePointerId), w = !0;
        T && Ft(T, c.currentTarget) ? !s.isOverTarget && s.pointerType != null && (s.isOverTarget = !0, w = L(ne(s.target, c), s.pointerType)) : s.isOverTarget && s.pointerType != null && (s.isOverTarget = !1, w = O(ne(s.target, c), s.pointerType, !1), B(ne(s.target, c))), w && c.stopPropagation();
      }, P.onTouchEnd = (c) => {
        if (!k(c.currentTarget, M(c.nativeEvent))) return;
        if (!s.isPressed) {
          c.stopPropagation();
          return;
        }
        let T = Ct(c.nativeEvent, s.activePointerId), w = !0;
        T && Ft(T, c.currentTarget) && s.pointerType != null ? (D(ne(s.target, c), s.pointerType), w = O(ne(s.target, c), s.pointerType), U(c.nativeEvent, s.target)) : s.isOverTarget && s.pointerType != null && (w = O(ne(s.target, c), s.pointerType, !1)), w && c.stopPropagation(), s.isPressed = !1, s.activePointerId = null, s.isOverTarget = !1, s.ignoreEmulatedMouseEvents = !0, s.target && !p && Ue(s.target), E();
      }, P.onTouchCancel = (c) => {
        k(c.currentTarget, M(c.nativeEvent)) && (c.stopPropagation(), s.isPressed && x(ne(s.target, c)));
      };
      let C = (c) => {
        s.isPressed && k(M(c), s.target) && x({
          currentTarget: s.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      P.onDragStart = (c) => {
        k(c.currentTarget, M(c.nativeEvent)) && x(c);
      };
    }
    return P;
  }, [
    h,
    a,
    d,
    E,
    p,
    x,
    B,
    O,
    L,
    D,
    j,
    U
  ]);
  return _(() => {
    if (!g || process.env.NODE_ENV === "test") return;
    const s = z(g.current);
    if (!s || !s.head || s.getElementById(St)) return;
    const P = s.createElement("style");
    P.id = St, P.textContent = `
@layer {
  [${Lt}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), s.head.prepend(P);
  }, [
    g
  ]), _(() => {
    let s = y.current;
    return () => {
      var P;
      p || Ue((P = s.target) !== null && P !== void 0 ? P : void 0);
      for (let F of s.disposables) F();
      s.disposables = [];
    };
  }, [
    p
  ]), {
    isPressed: u || m,
    pressProps: V(b, H, {
      [Lt]: !0
    })
  };
}
function pt(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function We(e, t) {
  const { key: n, code: r } = e, o = t, i = o.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(o instanceof Z(o).HTMLInputElement && !an(o, n) || o instanceof Z(o).HTMLTextAreaElement || o.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && pt(o)) && n !== "Enter");
}
function Lr(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function Ct(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const o = n[r];
    if (o.identifier === t) return o;
  }
  return null;
}
function ne(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function ce(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Cr(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function Fr(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Ft(e, t) {
  let n = t.getBoundingClientRect(), r = Cr(e);
  return Fr(n, r);
}
function Or(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !pt(e);
}
function Ot(e, t) {
  return e instanceof HTMLInputElement ? !an(e, t) : Or(e);
}
const Mr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function an(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : Mr.has(e.type);
}
let ge = null, Je = /* @__PURE__ */ new Set(), Pe = /* @__PURE__ */ new Map(), se = !1, Qe = !1;
const Dr = {
  Tab: !0,
  Escape: !0
};
function vt(e, t) {
  for (let n of Je) n(e, t);
}
function Ir(e) {
  return !(e.metaKey || !be() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ae(e) {
  se = !0, Ir(e) && (ge = "keyboard", vt("keyboard", e));
}
function Y(e) {
  ge = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (se = !0, vt("pointer", e));
}
function sn(e) {
  Ze(e) && (se = !0, ge = "virtual");
}
function cn(e) {
  e.target === window || e.target === document || He || !e.isTrusted || (!se && !Qe && (ge = "virtual", vt("virtual", e)), se = !1, Qe = !1);
}
function un() {
  He || (se = !1, Qe = !0);
}
function et(e) {
  if (typeof window > "u" || typeof document > "u" || Pe.get(Z(e))) return;
  const t = Z(e), n = z(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    se = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Ae, !0), n.addEventListener("keyup", Ae, !0), n.addEventListener("click", sn, !0), t.addEventListener("focus", cn, !0), t.addEventListener("blur", un, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Y, !0), n.addEventListener("pointermove", Y, !0), n.addEventListener("pointerup", Y, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Y, !0), n.addEventListener("mousemove", Y, !0), n.addEventListener("mouseup", Y, !0)), t.addEventListener("beforeunload", () => {
    dn(e);
  }, {
    once: !0
  }), Pe.set(t, {
    focus: r
  });
}
const dn = (e, t) => {
  const n = Z(e), r = z(e);
  t && r.removeEventListener("DOMContentLoaded", t), Pe.has(n) && (n.HTMLElement.prototype.focus = Pe.get(n).focus, r.removeEventListener("keydown", Ae, !0), r.removeEventListener("keyup", Ae, !0), r.removeEventListener("click", sn, !0), n.removeEventListener("focus", cn, !0), n.removeEventListener("blur", un, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Y, !0), r.removeEventListener("pointermove", Y, !0), r.removeEventListener("pointerup", Y, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Y, !0), r.removeEventListener("mousemove", Y, !0), r.removeEventListener("mouseup", Y, !0)), Pe.delete(n));
};
function kr(e) {
  const t = z(e);
  let n;
  return t.readyState !== "loading" ? et(e) : (n = () => {
    et(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => dn(e, n);
}
typeof document < "u" && kr();
function bt() {
  return ge !== "pointer";
}
function fn() {
  return ge;
}
const Hr = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ar(e, t, n) {
  let r = z(n == null ? void 0 : n.target);
  const o = typeof window < "u" ? Z(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? Z(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, l = typeof window < "u" ? Z(n == null ? void 0 : n.target).HTMLElement : HTMLElement, a = typeof window < "u" ? Z(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof o && !Hr.has(r.activeElement.type) || r.activeElement instanceof i || r.activeElement instanceof l && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof a && !Dr[n.key]);
}
function Nr(e, t, n) {
  et(), _(() => {
    let r = (o, i) => {
      Ar(!!(n != null && n.isTextInput), o, i) && e(bt());
    };
    return Je.add(r), () => {
      Je.delete(r);
    };
  }, t);
}
function Rr(e) {
  const t = z(e), n = Ee(t);
  if (fn() === "virtual") {
    let r = n;
    Xt(() => {
      Ee(t) === r && e.isConnected && ve(e);
    });
  } else ve(e);
}
function pn(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: o } = e;
  const i = N((u) => {
    if (u.target === u.currentTarget)
      return r && r(u), o && o(!1), !0;
  }, [
    r,
    o
  ]), l = nn(i), a = N((u) => {
    const d = z(u.target), f = d ? Ee(d) : Ee();
    u.target === u.currentTarget && f === M(u.nativeEvent) && (n && n(u), o && o(!0), l(u));
  }, [
    o,
    n,
    l
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || o || r) ? a : void 0,
      onBlur: !t && (r || o) ? i : void 0
    }
  };
}
function Mt(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Kr(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Mt(e.onKeyDown),
      onKeyUp: Mt(e.onKeyUp)
    }
  };
}
let vn = /* @__PURE__ */ S.createContext(null);
function _r(e) {
  let t = W(vn) || {};
  qt(t, e);
  let { ref: n, ...r } = t;
  return r;
}
const Vr = /* @__PURE__ */ S.forwardRef(function(t, n) {
  let { children: r, ...o } = t, i = Zt(n), l = {
    ...o,
    ref: i
  };
  return /* @__PURE__ */ S.createElement(vn.Provider, {
    value: l
  }, r);
});
function $t(e, t) {
  let { focusProps: n } = pn(e), { keyboardProps: r } = Kr(e), o = V(n, r), i = _r(t), l = e.isDisabled ? {} : i, a = I(e.autoFocus);
  _(() => {
    a.current && t.current && Rr(t.current), a.current = !1;
  }, [
    t
  ]);
  let u = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (u = void 0), {
    focusableProps: V({
      ...o,
      tabIndex: u
    }, l)
  };
}
function zr(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: o } = e, i = I({
    isFocusWithin: !1
  }), { addGlobalListener: l, removeAllGlobalListeners: a } = dt(), u = N((p) => {
    p.currentTarget.contains(p.target) && i.current.isFocusWithin && !p.currentTarget.contains(p.relatedTarget) && (i.current.isFocusWithin = !1, a(), n && n(p), o && o(!1));
  }, [
    n,
    o,
    i,
    a
  ]), d = nn(u), f = N((p) => {
    if (!p.currentTarget.contains(p.target)) return;
    const g = z(p.target), b = Ee(g);
    if (!i.current.isFocusWithin && b === M(p.nativeEvent)) {
      r && r(p), o && o(!0), i.current.isFocusWithin = !0, d(p);
      let m = p.currentTarget;
      l(g, "focus", ($) => {
        if (i.current.isFocusWithin && !k(m, $.target)) {
          let y = new g.defaultView.FocusEvent("blur", {
            relatedTarget: $.target
          });
          tn(y, m);
          let h = ft(y);
          u(h);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    o,
    d,
    l,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: f,
      onBlur: u
    }
  };
}
let Ne = !1, je = 0;
function tt() {
  Ne = !0, setTimeout(() => {
    Ne = !1;
  }, 50);
}
function Dt(e) {
  e.pointerType === "touch" && tt();
}
function Br() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Dt) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", tt), je++, () => {
      je--, !(je > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Dt) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", tt));
    };
}
function Ce(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: o } = e, [i, l] = G(!1), a = I({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  _(Br, []);
  let { addGlobalListener: u, removeAllGlobalListeners: d } = dt(), { hoverProps: f, triggerHoverEnd: p } = ie(() => {
    let g = ($, y) => {
      if (a.pointerType = y, o || y === "touch" || a.isHovered || !$.currentTarget.contains($.target)) return;
      a.isHovered = !0;
      let h = $.currentTarget;
      a.target = h, u(z($.target), "pointerover", (E) => {
        a.isHovered && a.target && !k(a.target, E.target) && b(E, E.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: h,
        pointerType: y
      }), n && n(!0), l(!0);
    }, b = ($, y) => {
      let h = a.target;
      a.pointerType = "", a.target = null, !(y === "touch" || !a.isHovered || !h) && (a.isHovered = !1, d(), r && r({
        type: "hoverend",
        target: h,
        pointerType: y
      }), n && n(!1), l(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = ($) => {
      Ne && $.pointerType === "mouse" || g($, $.pointerType);
    }, m.onPointerLeave = ($) => {
      !o && $.currentTarget.contains($.target) && b($, $.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      a.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = ($) => {
      !a.ignoreEmulatedMouseEvents && !Ne && g($, "mouse"), a.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = ($) => {
      !o && $.currentTarget.contains($.target) && b($, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: b
    };
  }, [
    t,
    n,
    r,
    o,
    a,
    u,
    d
  ]);
  return _(() => {
    o && p({
      currentTarget: a.target
    }, a.pointerType);
  }, [
    o
  ]), {
    hoverProps: f,
    isHovered: i
  };
}
function Ur(e, t) {
  let { elementType: n = "a", onPress: r, onPressStart: o, onPressEnd: i, onClick: l, isDisabled: a, ...u } = e, d = {};
  n !== "a" && (d = {
    role: "link",
    tabIndex: a ? void 0 : 0
  });
  let { focusableProps: f } = $t(e, t), { pressProps: p, isPressed: g } = ln({
    onPress: r,
    onPressStart: o,
    onPressEnd: i,
    onClick: l,
    isDisabled: a,
    ref: t
  }), b = xe(u, {
    labelable: !0
  }), m = V(f, p), $ = Yt(), y = lr(e);
  return {
    isPressed: g,
    linkProps: V(b, y, {
      ...m,
      ...d,
      "aria-disabled": a || void 0,
      "aria-current": e["aria-current"],
      onClick: (h) => {
        var E;
        (E = p.onClick) === null || E === void 0 || E.call(p, h), !$.isNative && h.currentTarget instanceof HTMLAnchorElement && h.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
        !h.isDefaultPrevented() && rr(h.currentTarget, h) && e.href && (h.preventDefault(), $.open(h.currentTarget, h, e.href, e.routerOptions));
      }
    })
  };
}
const Wr = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), jr = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Gr(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return Wr.has(n.script);
  }
  let t = e.split("-")[0];
  return jr.has(t);
}
const Yr = Symbol.for("react-aria.i18n.locale");
function bn() {
  let e = typeof window < "u" && window[Yr] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Gr(e) ? "rtl" : "ltr"
  };
}
let nt = bn(), ye = /* @__PURE__ */ new Set();
function It() {
  nt = bn();
  for (let e of ye) e(nt);
}
function Xr() {
  let e = lt(), [t, n] = G(nt);
  return _(() => (ye.size === 0 && window.addEventListener("languagechange", It), ye.add(n), () => {
    ye.delete(n), ye.size === 0 && window.removeEventListener("languagechange", It);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const Zr = /* @__PURE__ */ S.createContext(null);
function $n() {
  let e = Xr();
  return W(Zr) || e;
}
let Ge = /* @__PURE__ */ new Map(), rt = !1;
try {
  rt = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Re = !1;
try {
  Re = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const gn = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class qr {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let n = "";
    if (!rt && this.options.signDisplay != null ? n = Qr(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !Re) {
      var r;
      let { unit: o, unitDisplay: i = "short", locale: l } = this.resolvedOptions();
      if (!o) return n;
      let a = (r = gn[o]) === null || r === void 0 ? void 0 : r[i];
      n += a[l] || a.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), o = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !rt && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !Re && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, n = {}) {
    this.numberFormatter = Jr(t, n), this.options = n;
  }
}
function Jr(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Re) {
    var r;
    let { unit: l, unitDisplay: a = "short" } = t;
    if (!l) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = gn[l]) === null || r === void 0) && r[a])) throw new Error(`Unsupported unit ${l} with unitDisplay = ${a}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let o = e + (t ? Object.entries(t).sort((l, a) => l[0] < a[0] ? -1 : 1).join() : "");
  if (Ge.has(o)) return Ge.get(o);
  let i = new Intl.NumberFormat(e, t);
  return Ge.set(o, i), i;
}
function Qr(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let o = e.format(-n), i = e.format(n), l = o.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...l
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), o.replace(i, "!!!").replace(l, "+").replace("!!!", i);
    } else return e.format(n);
  }
}
function eo(e = {}) {
  let { locale: t } = $n();
  return ie(() => new qr(t, e), [
    t,
    e
  ]);
}
function mn(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: o, onPressStart: i, onPressEnd: l, onPressUp: a, onPressChange: u, preventFocusOnPress: d, allowFocusWhenDisabled: f, onClick: p, href: g, target: b, rel: m, type: $ = "button" } = e, y;
  n === "button" ? y = {
    type: $,
    disabled: r
  } : y = {
    role: "button",
    href: n === "a" && !r ? g : void 0,
    target: n === "a" ? b : void 0,
    type: n === "input" ? $ : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? m : void 0
  };
  let { pressProps: h, isPressed: E } = ln({
    onPressStart: i,
    onPressEnd: l,
    onPressChange: u,
    onPress: o,
    onPressUp: a,
    onClick: p,
    isDisabled: r,
    preventFocusOnPress: d,
    ref: t
  }), { focusableProps: L } = $t(e, t);
  f && (L.tabIndex = r ? -1 : L.tabIndex);
  let O = V(L, h, xe(e, {
    labelable: !0
  }));
  return {
    isPressed: E,
    buttonProps: V(y, O, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"]
    })
  };
}
function hn(e, t, n) {
  const { isSelected: r } = t, { isPressed: o, buttonProps: i } = mn({
    ...e,
    onPress: at(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: o,
    isSelected: r,
    isDisabled: e.isDisabled || !1,
    buttonProps: V(i, {
      "aria-pressed": r
    })
  };
}
function gt(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, o = I({
    isFocused: !1,
    isFocusVisible: t || bt()
  }), [i, l] = G(!1), [a, u] = G(() => o.current.isFocused && o.current.isFocusVisible), d = N(() => u(o.current.isFocused && o.current.isFocusVisible), []), f = N((b) => {
    o.current.isFocused = b, l(b), d();
  }, [
    d
  ]);
  Nr((b) => {
    o.current.isFocusVisible = b, d();
  }, [], {
    isTextInput: n
  });
  let { focusProps: p } = pn({
    isDisabled: r,
    onFocusChange: f
  }), { focusWithinProps: g } = zr({
    isDisabled: !r,
    onFocusWithinChange: f
  });
  return {
    isFocused: i,
    isFocusVisible: a,
    focusProps: r ? g : p
  };
}
function to(e, t, n) {
  let r = {
    isSelected: t.selectedKeys.has(e.id),
    setSelected(u) {
      t.setSelected(e.id, u);
    },
    toggle() {
      t.toggleKey(e.id);
    }
  }, { isPressed: o, isSelected: i, isDisabled: l, buttonProps: a } = hn({
    ...e,
    id: void 0,
    isDisabled: e.isDisabled || t.isDisabled
  }, r, n);
  return t.selectionMode === "single" && (a.role = "radio", a["aria-checked"] = r.isSelected, delete a["aria-pressed"]), {
    isPressed: o,
    isSelected: i,
    isDisabled: l,
    buttonProps: a
  };
}
const yn = 7e3;
let J = null;
function kt(e, t = "assertive", n = yn) {
  J ? J.announce(e, t, n) : (J = new no(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? J.announce(e, t, n) : setTimeout(() => {
    J != null && J.isAttached() && (J == null || J.announce(e, t, n));
  }, 100));
}
class no {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = yn) {
    var o, i;
    if (!this.node) return;
    let l = document.createElement("div");
    typeof t == "object" ? (l.setAttribute("role", "img"), l.setAttribute("aria-labelledby", t["aria-labelledby"])) : l.textContent = t, n === "assertive" ? (o = this.assertiveLog) === null || o === void 0 || o.appendChild(l) : (i = this.politeLog) === null || i === void 0 || i.appendChild(l), t !== "" && setTimeout(() => {
      l.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function ro(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": o, labelElementType: i = "label" } = e;
  t = pe(t);
  let l = pe(), a = {};
  n ? (r = r ? `${l} ${r}` : l, a = {
    id: l,
    htmlFor: i === "label" ? t : void 0
  }) : !r && !o && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = sr({
    id: t,
    "aria-label": o,
    "aria-labelledby": r
  });
  return {
    labelProps: a,
    fieldProps: u
  };
}
function oo(e = {}) {
  let { isReadOnly: t } = e, [n, r] = en(e.isSelected, e.defaultSelected || !1, e.onChange);
  function o(l) {
    t || r(l);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    setSelected: o,
    toggle: i
  };
}
const Q = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, Ke = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, io = {
  top: "left",
  left: "top"
}, ot = {
  top: "height",
  left: "width"
}, Pn = {
  width: "totalWidth",
  height: "totalHeight"
}, De = {};
let R = typeof document < "u" ? window.visualViewport : null;
function Ht(e) {
  let t = 0, n = 0, r = 0, o = 0, i = 0, l = 0, a = {};
  var u;
  let d = ((u = R == null ? void 0 : R.scale) !== null && u !== void 0 ? u : 1) > 1;
  if (e.tagName === "BODY") {
    let m = document.documentElement;
    r = m.clientWidth, o = m.clientHeight;
    var f;
    t = (f = R == null ? void 0 : R.width) !== null && f !== void 0 ? f : r;
    var p;
    n = (p = R == null ? void 0 : R.height) !== null && p !== void 0 ? p : o, a.top = m.scrollTop || e.scrollTop, a.left = m.scrollLeft || e.scrollLeft, R && (i = R.offsetTop, l = R.offsetLeft);
  } else
    ({ width: t, height: n, top: i, left: l } = fe(e)), a.top = e.scrollTop, a.left = e.scrollLeft, r = t, o = n;
  if (jt() && (e.tagName === "BODY" || e.tagName === "HTML") && d) {
    a.top = 0, a.left = 0;
    var g;
    i = (g = R == null ? void 0 : R.pageTop) !== null && g !== void 0 ? g : 0;
    var b;
    l = (b = R == null ? void 0 : R.pageLeft) !== null && b !== void 0 ? b : 0;
  }
  return {
    width: t,
    height: n,
    totalWidth: r,
    totalHeight: o,
    scroll: a,
    top: i,
    left: l
  };
}
function lo(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function At(e, t, n, r, o, i, l) {
  var a;
  let u = (a = o.scroll[e]) !== null && a !== void 0 ? a : 0, d = r[ot[e]], f = r.scroll[Q[e]] + i, p = d + r.scroll[Q[e]] - i, g = t - u + l[e] - r[Q[e]], b = t - u + n + l[e] - r[Q[e]];
  return g < f ? f - g : b > p ? Math.max(p - b, f - g) : 0;
}
function ao(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function Nt(e) {
  if (De[e]) return De[e];
  let [t, n] = e.split(" "), r = Q[t] || "right", o = io[r];
  Q[n] || (n = "center");
  let i = ot[r], l = ot[o];
  return De[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: o,
    size: i,
    crossSize: l
  }, De[e];
}
function Ye(e, t, n, r, o, i, l, a, u, d) {
  let { placement: f, crossPlacement: p, axis: g, crossAxis: b, size: m, crossSize: $ } = r, y = {};
  var h;
  y[b] = (h = e[b]) !== null && h !== void 0 ? h : 0;
  var E, L, O, D;
  p === "center" ? y[b] += (((E = e[$]) !== null && E !== void 0 ? E : 0) - ((L = n[$]) !== null && L !== void 0 ? L : 0)) / 2 : p !== b && (y[b] += ((O = e[$]) !== null && O !== void 0 ? O : 0) - ((D = n[$]) !== null && D !== void 0 ? D : 0)), y[b] += i;
  const x = e[b] - n[$] + u + d, B = e[b] + e[$] - u - d;
  if (y[b] = Te(y[b], x, B), f === g) {
    const j = a ? l[m] : t[Pn[m]];
    y[Ke[g]] = Math.floor(j - e[g] + o);
  } else y[g] = Math.floor(e[g] + e[m] + o);
  return y;
}
function so(e, t, n, r, o, i, l, a) {
  const u = r ? n.height : t[Pn.height];
  var d;
  let f = e.top != null ? n.top + e.top : n.top + (u - ((d = e.bottom) !== null && d !== void 0 ? d : 0) - l);
  var p, g, b, m, $, y;
  let h = a !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, t.height + t.top + ((p = t.scroll.top) !== null && p !== void 0 ? p : 0) - f - (((g = o.top) !== null && g !== void 0 ? g : 0) + ((b = o.bottom) !== null && b !== void 0 ? b : 0) + i))
  ) : Math.max(0, f + l - (t.top + ((m = t.scroll.top) !== null && m !== void 0 ? m : 0)) - ((($ = o.top) !== null && $ !== void 0 ? $ : 0) + ((y = o.bottom) !== null && y !== void 0 ? y : 0) + i));
  return Math.min(t.height - i * 2, h);
}
function Rt(e, t, n, r, o, i) {
  let { placement: l, axis: a, size: u } = i;
  var d, f;
  if (l === a) return Math.max(0, n[a] - e[a] - ((d = e.scroll[a]) !== null && d !== void 0 ? d : 0) + t[a] - ((f = r[a]) !== null && f !== void 0 ? f : 0) - r[Ke[a]] - o);
  var p;
  return Math.max(0, e[u] + e[a] + e.scroll[a] - t[a] - n[a] - n[u] - ((p = r[a]) !== null && p !== void 0 ? p : 0) - r[Ke[a]] - o);
}
function co(e, t, n, r, o, i, l, a, u, d, f, p, g, b, m, $) {
  let y = Nt(e), { size: h, crossAxis: E, crossSize: L, placement: O, crossPlacement: D } = y, x = Ye(t, a, n, y, f, p, d, g, m, $), B = f, j = Rt(a, d, t, o, i + f, y);
  if (l && r[h] > j) {
    let ze = Nt(`${Ke[O]} ${D}`), Cn = Ye(t, a, n, ze, f, p, d, g, m, $);
    Rt(a, d, t, o, i + f, ze) > j && (y = ze, x = Cn, B = f);
  }
  let U = "bottom";
  y.axis === "top" ? y.placement === "top" ? U = "top" : y.placement === "bottom" && (U = "bottom") : y.crossAxis === "top" && (y.crossPlacement === "top" ? U = "bottom" : y.crossPlacement === "bottom" && (U = "top"));
  let H = At(E, x[E], n[L], a, u, i, d);
  x[E] += H;
  let s = so(x, a, d, g, o, i, n.height, U);
  b && b < s && (s = b), n.height = Math.min(n.height, s), x = Ye(t, a, n, y, B, p, d, g, m, $), H = At(E, x[E], n[L], a, u, i, d), x[E] += H;
  let P = {}, F = t[E] + 0.5 * t[L] - x[E] - o[Q[E]];
  const v = m / 2 + $;
  var C, c, T, w;
  const K = Q[E] === "left" ? ((C = o.left) !== null && C !== void 0 ? C : 0) + ((c = o.right) !== null && c !== void 0 ? c : 0) : ((T = o.top) !== null && T !== void 0 ? T : 0) + ((w = o.bottom) !== null && w !== void 0 ? w : 0), Ve = n[L] - K - m / 2 - $, xn = t[E] + m / 2 - (x[E] + o[Q[E]]), Sn = t[E] + t[L] - m / 2 - (x[E] + o[Q[E]]), Ln = Te(F, xn, Sn);
  return P[E] = Te(Ln, v, Ve), {
    position: x,
    maxHeight: s,
    arrowOffsetLeft: P.left,
    arrowOffsetTop: P.top,
    placement: y.placement
  };
}
function uo(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: o, padding: i, shouldFlip: l, boundaryElement: a, offset: u, crossOffset: d, maxHeight: f, arrowSize: p = 0, arrowBoundaryOffset: g = 0 } = e, b = r instanceof HTMLElement ? fo(r) : document.documentElement, m = b === document.documentElement;
  const $ = window.getComputedStyle(b).position;
  let y = !!$ && $ !== "static", h = m ? fe(n) : Kt(n, b);
  if (!m) {
    let { marginTop: P, marginLeft: F } = window.getComputedStyle(n);
    h.top += parseInt(P, 10) || 0, h.left += parseInt(F, 10) || 0;
  }
  let E = fe(r), L = ao(r);
  var O, D;
  E.width += ((O = L.left) !== null && O !== void 0 ? O : 0) + ((D = L.right) !== null && D !== void 0 ? D : 0);
  var x, B;
  E.height += ((x = L.top) !== null && x !== void 0 ? x : 0) + ((B = L.bottom) !== null && B !== void 0 ? B : 0);
  let j = lo(o), U = Ht(a), H = Ht(b), s = a.tagName === "BODY" ? fe(b) : Kt(b, a);
  return b.tagName === "HTML" && a.tagName === "BODY" && (H.scroll.top = 0, H.scroll.left = 0), co(t, h, E, j, L, i, l, U, H, s, u, d, y, f, p, g);
}
function fe(e) {
  let { top: t, left: n, width: r, height: o } = e.getBoundingClientRect(), { scrollTop: i, scrollLeft: l, clientTop: a, clientLeft: u } = document.documentElement;
  return {
    top: t + i - a,
    left: n + l - u,
    width: r,
    height: o
  };
}
function Kt(e, t) {
  let n = window.getComputedStyle(e), r;
  if (n.position === "fixed") {
    let { top: o, left: i, width: l, height: a } = e.getBoundingClientRect();
    r = {
      top: o,
      left: i,
      width: l,
      height: a
    };
  } else {
    r = fe(e);
    let o = fe(t), i = window.getComputedStyle(t);
    o.top += (parseInt(i.borderTopWidth, 10) || 0) - t.scrollTop, o.left += (parseInt(i.borderLeftWidth, 10) || 0) - t.scrollLeft, r.top -= o.top, r.left -= o.left;
  }
  return r.top -= parseInt(n.marginTop, 10) || 0, r.left -= parseInt(n.marginLeft, 10) || 0, r;
}
function fo(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !_t(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !_t(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function _t(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const po = /* @__PURE__ */ new WeakMap();
function vo(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  _(() => {
    if (!n || r === null) return;
    let o = (i) => {
      let l = i.target;
      if (!t.current || l instanceof Node && !l.contains(t.current) || i.target instanceof HTMLInputElement || i.target instanceof HTMLTextAreaElement) return;
      let a = r || po.get(t.current);
      a && a();
    };
    return window.addEventListener("scroll", o, !0), () => {
      window.removeEventListener("scroll", o, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
let A = typeof document < "u" ? window.visualViewport : null;
function bo(e) {
  let { direction: t } = $n(), { arrowSize: n = 0, targetRef: r, overlayRef: o, scrollRef: i = o, placement: l = "bottom", containerPadding: a = 12, shouldFlip: u = !0, boundaryElement: d = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: p = 0, shouldUpdatePosition: g = !0, isOpen: b = !0, onClose: m, maxHeight: $, arrowBoundaryOffset: y = 0 } = e, [h, E] = G(null), L = [
    g,
    l,
    o.current,
    r.current,
    i.current,
    a,
    u,
    d,
    f,
    p,
    b,
    t,
    $,
    y,
    n
  ], O = I(A == null ? void 0 : A.scale);
  _(() => {
    b && (O.current = A == null ? void 0 : A.scale);
  }, [
    b
  ]);
  let D = N(() => {
    if (g === !1 || !b || !o.current || !r.current || !d || (A == null ? void 0 : A.scale) !== O.current) return;
    let H = null;
    if (i.current && i.current.contains(document.activeElement)) {
      var s;
      let w = (s = document.activeElement) === null || s === void 0 ? void 0 : s.getBoundingClientRect(), K = i.current.getBoundingClientRect();
      var P;
      if (H = {
        type: "top",
        offset: ((P = w == null ? void 0 : w.top) !== null && P !== void 0 ? P : 0) - K.top
      }, H.offset > K.height / 2) {
        H.type = "bottom";
        var F;
        H.offset = ((F = w == null ? void 0 : w.bottom) !== null && F !== void 0 ? F : 0) - K.bottom;
      }
    }
    let v = o.current;
    if (!$ && o.current) {
      var C;
      v.style.top = "0px", v.style.bottom = "";
      var c;
      v.style.maxHeight = ((c = (C = window.visualViewport) === null || C === void 0 ? void 0 : C.height) !== null && c !== void 0 ? c : window.innerHeight) + "px";
    }
    let T = uo({
      placement: go(l, t),
      overlayNode: o.current,
      targetNode: r.current,
      scrollNode: i.current || o.current,
      padding: a,
      shouldFlip: u,
      boundaryElement: d,
      offset: f,
      crossOffset: p,
      maxHeight: $,
      arrowSize: n,
      arrowBoundaryOffset: y
    });
    if (T.position) {
      if (v.style.top = "", v.style.bottom = "", v.style.left = "", v.style.right = "", Object.keys(T.position).forEach((w) => v.style[w] = T.position[w] + "px"), v.style.maxHeight = T.maxHeight != null ? T.maxHeight + "px" : "", H && document.activeElement && i.current) {
        let w = document.activeElement.getBoundingClientRect(), K = i.current.getBoundingClientRect(), Ve = w[H.type] - K[H.type];
        i.current.scrollTop += Ve - H.offset;
      }
      E(T);
    }
  }, L);
  q(D, L), $o(D), Pt({
    ref: o,
    onResize: D
  }), Pt({
    ref: r,
    onResize: D
  });
  let x = I(!1);
  q(() => {
    let H, s = () => {
      x.current = !0, clearTimeout(H), H = setTimeout(() => {
        x.current = !1;
      }, 500), D();
    }, P = () => {
      x.current && s();
    };
    return A == null || A.addEventListener("resize", s), A == null || A.addEventListener("scroll", P), () => {
      A == null || A.removeEventListener("resize", s), A == null || A.removeEventListener("scroll", P);
    };
  }, [
    D
  ]);
  let B = N(() => {
    x.current || m == null || m();
  }, [
    m,
    x
  ]);
  vo({
    triggerRef: r,
    isOpen: b,
    onClose: m && B
  });
  var j, U;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...h == null ? void 0 : h.position,
        maxHeight: (j = h == null ? void 0 : h.maxHeight) !== null && j !== void 0 ? j : "100vh"
      }
    },
    placement: (U = h == null ? void 0 : h.placement) !== null && U !== void 0 ? U : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: h == null ? void 0 : h.arrowOffsetLeft,
        top: h == null ? void 0 : h.arrowOffsetTop
      }
    },
    updatePosition: D
  };
}
function $o(e) {
  q(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function go(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
const mo = /* @__PURE__ */ X({});
function ho() {
  var e;
  return (e = W(mo)) !== null && e !== void 0 ? e : {};
}
const it = /* @__PURE__ */ S.createContext(null);
function yo(e) {
  let { children: t } = e, n = W(it), [r, o] = G(0), i = ie(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      o((l) => l + 1), n && n.addModal();
    },
    removeModal() {
      o((l) => l - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ S.createElement(it.Provider, {
    value: i
  }, t);
}
function Po() {
  let e = W(it);
  return {
    modalProviderProps: {
      "aria-hidden": e && e.modalCount > 0 ? !0 : void 0
    }
  };
}
function Eo(e) {
  let { modalProviderProps: t } = Po();
  return /* @__PURE__ */ S.createElement("div", {
    "data-overlay-container": !0,
    ...e,
    ...t
  });
}
function To(e) {
  return /* @__PURE__ */ S.createElement(yo, null, /* @__PURE__ */ S.createElement(Eo, e));
}
function wo(e) {
  let t = lt(), { portalContainer: n = t ? null : document.body, ...r } = e, { getContainer: o } = ho();
  if (!e.portalContainer && o && (n = o()), S.useEffect(() => {
    if (n != null && n.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let i = /* @__PURE__ */ S.createElement(To, r);
  return /* @__PURE__ */ Fn.createPortal(i, n);
}
function xo(e) {
  let { value: t = 0, minValue: n = 0, maxValue: r = 100, valueLabel: o, isIndeterminate: i, formatOptions: l = {
    style: "percent"
  } } = e, a = xe(e, {
    labelable: !0
  }), { labelProps: u, fieldProps: d } = ro({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = Te(t, n, r);
  let f = (t - n) / (r - n), p = eo(l);
  if (!i && !o) {
    let g = l.style === "percent" ? f : t;
    o = p.format(g);
  }
  return {
    progressBarProps: V(a, {
      ...d,
      "aria-valuenow": i ? void 0 : t,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": i ? void 0 : o,
      role: "progressbar"
    }),
    labelProps: u
  };
}
function So(e, t) {
  let n = xe(e, {
    labelable: !0
  }), { hoverProps: r } = Ce({
    onHoverStart: () => t == null ? void 0 : t.open(!0),
    onHoverEnd: () => t == null ? void 0 : t.close()
  });
  return {
    tooltipProps: V(n, r, {
      role: "tooltip"
    })
  };
}
function Lo(e, t, n) {
  let { isDisabled: r, trigger: o } = e, i = pe(), l = I(!1), a = I(!1), u = () => {
    (l.current || a.current) && t.open(a.current);
  }, d = (h) => {
    !l.current && !a.current && t.close(h);
  };
  _(() => {
    let h = (E) => {
      n && n.current && E.key === "Escape" && (E.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", h, !0), () => {
        document.removeEventListener("keydown", h, !0);
      };
  }, [
    n,
    t
  ]);
  let f = () => {
    o !== "focus" && (fn() === "pointer" ? l.current = !0 : l.current = !1, u());
  }, p = () => {
    o !== "focus" && (a.current = !1, l.current = !1, d());
  }, g = () => {
    a.current = !1, l.current = !1, d(!0);
  }, b = () => {
    bt() && (a.current = !0, u());
  }, m = () => {
    a.current = !1, l.current = !1, d(!0);
  }, { hoverProps: $ } = Ce({
    isDisabled: r,
    onHoverStart: f,
    onHoverEnd: p
  }), { focusableProps: y } = $t({
    isDisabled: r,
    onFocus: b,
    onBlur: m
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? i : void 0,
      ...V(y, $, {
        onPointerDown: g,
        onKeyDown: g,
        tabIndex: void 0
      })
    },
    tooltipProps: {
      id: i
    }
  };
}
const Co = /* @__PURE__ */ X({}), En = /* @__PURE__ */ X(null), Bo = /* @__PURE__ */ we(function(t, n) {
  [t, n] = Le(t, n, En);
  let { value: r = 0, minValue: o = 0, maxValue: i = 100, isIndeterminate: l = !1 } = t;
  r = Te(r, o, i);
  let [a, u] = mr(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: d, labelProps: f } = xo({
    ...t,
    label: u
  }), p = l ? void 0 : (r - o) / (i - o) * 100, g = Se({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: p,
      valueText: d["aria-valuetext"],
      isIndeterminate: l
    }
  });
  return /* @__PURE__ */ S.createElement("div", {
    ...d,
    ...g,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ S.createElement(Co.Provider, {
    value: {
      ...f,
      ref: a,
      elementType: "span"
    }
  }, g.children));
}), Fo = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), Oo = /* @__PURE__ */ X({}), Uo = /* @__PURE__ */ yr(function(t, n) {
  [t, n] = Le(t, n, Oo), t = Mo(t);
  let r = t, { isPending: o } = r, { buttonProps: i, isPressed: l } = mn(t, n), { focusProps: a, isFocused: u, isFocusVisible: d } = gt(t), { hoverProps: f, isHovered: p } = Ce({
    ...t,
    isDisabled: t.isDisabled || o
  }), g = {
    isHovered: p,
    isPressed: (r.isPressed || l) && !o,
    isFocused: u,
    isFocusVisible: d,
    isDisabled: t.isDisabled || !1,
    isPending: o ?? !1
  }, b = Se({
    ...t,
    values: g,
    defaultClassName: "react-aria-Button"
  }), m = pe(i.id), $ = pe(), y = i["aria-labelledby"];
  o && (y ? y = `${y} ${$}` : i["aria-label"] && (y = `${m} ${$}`));
  let h = I(o);
  return _(() => {
    let E = {
      "aria-labelledby": y || m
    };
    (!h.current && u && o || h.current && u && !o) && kt(E, "assertive"), h.current = o;
  }, [
    o,
    u,
    y,
    m
  ]), /* @__PURE__ */ S.createElement("button", {
    ...xe(t, {
      propNames: Fo
    }),
    ...V(i, a, f),
    ...b,
    type: i.type === "submit" && o ? "button" : i.type,
    id: m,
    ref: n,
    "aria-labelledby": y,
    slot: t.slot || void 0,
    "aria-disabled": o ? "true" : i["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": g.isPressed || void 0,
    "data-hovered": p || void 0,
    "data-focused": u || void 0,
    "data-pending": o || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ S.createElement(En.Provider, {
    value: {
      id: $
    }
  }, b.children));
});
function Mo(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
function Do(e) {
  let [t, n] = en(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = N(() => {
    n(!0);
  }, [
    n
  ]), o = N(() => {
    n(!1);
  }, [
    n
  ]), i = N(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: o,
    toggle: i
  };
}
const Io = 1500, Vt = 500;
let le = {}, ko = 0, me = !1, ee = null, ae = null;
function Tn(e = {}) {
  let { delay: t = Io, closeDelay: n = Vt } = e, { isOpen: r, open: o, close: i } = Do(e), l = ie(() => `${++ko}`, []), a = I(null), u = I(i), d = () => {
    le[l] = g;
  }, f = () => {
    for (let m in le) m !== l && (le[m](!0), delete le[m]);
  }, p = () => {
    a.current && clearTimeout(a.current), a.current = null, f(), d(), me = !0, o(), ee && (clearTimeout(ee), ee = null), ae && (clearTimeout(ae), ae = null);
  }, g = (m) => {
    m || n <= 0 ? (a.current && clearTimeout(a.current), a.current = null, u.current()) : a.current || (a.current = setTimeout(() => {
      a.current = null, u.current();
    }, n)), ee && (clearTimeout(ee), ee = null), me && (ae && clearTimeout(ae), ae = setTimeout(() => {
      delete le[l], ae = null, me = !1;
    }, Math.max(Vt, n)));
  }, b = () => {
    f(), d(), !r && !ee && !me ? ee = setTimeout(() => {
      ee = null, me = !0, p();
    }, t) : r || p();
  };
  return _(() => {
    u.current = i;
  }, [
    i
  ]), _(() => () => {
    a.current && clearTimeout(a.current), le[l] && delete le[l];
  }, [
    l
  ]), {
    isOpen: r,
    open: (m) => {
      !m && t > 0 && !a.current ? b() : p();
    },
    close: g
  };
}
const Ho = /* @__PURE__ */ X(null), Wo = /* @__PURE__ */ we(function(t, n) {
  [t, n] = Le(t, n, Ho);
  let r = t.href && !t.isDisabled ? "a" : "span", { linkProps: o, isPressed: i } = Ur({
    ...t,
    elementType: r
  }, n), { hoverProps: l, isHovered: a } = Ce(t), { focusProps: u, isFocused: d, isFocusVisible: f } = gt(), p = Se({
    ...t,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!t["aria-current"],
      isDisabled: t.isDisabled || !1,
      isPressed: i,
      isHovered: a,
      isFocused: d,
      isFocusVisible: f
    }
  });
  return /* @__PURE__ */ S.createElement(r, {
    ref: n,
    slot: t.slot || void 0,
    ...V(p, o, l, u),
    "data-focused": d || void 0,
    "data-hovered": a || void 0,
    "data-pressed": i || void 0,
    "data-focus-visible": f || void 0,
    "data-current": !!t["aria-current"] || void 0,
    "data-disabled": t.isDisabled || void 0
  }, p.children);
}), Ao = /* @__PURE__ */ X({
  placement: "bottom"
}), No = /* @__PURE__ */ X(null), Ro = /* @__PURE__ */ X({}), jo = /* @__PURE__ */ we(function(t, n) {
  [t, n] = Le(t, n, Ro);
  let r = W(No), o = oo(r && t.id != null ? {
    isSelected: r.selectedKeys.has(t.id),
    onChange($) {
      r.setSelected(t.id, $);
    }
  } : t), { buttonProps: i, isPressed: l, isSelected: a, isDisabled: u } = r && t.id != null ? to({
    ...t,
    id: t.id
  }, r, n) : hn({
    ...t,
    id: t.id != null ? String(t.id) : void 0
  }, o, n), { focusProps: d, isFocused: f, isFocusVisible: p } = gt(t), { hoverProps: g, isHovered: b } = Ce(t), m = Se({
    ...t,
    id: void 0,
    values: {
      isHovered: b,
      isPressed: l,
      isFocused: f,
      isSelected: o.isSelected,
      isFocusVisible: p,
      isDisabled: u,
      state: o
    },
    defaultClassName: "react-aria-ToggleButton"
  });
  return /* @__PURE__ */ S.createElement("button", {
    ...V(i, d, g),
    ...m,
    ref: n,
    slot: t.slot || void 0,
    "data-focused": f || void 0,
    "data-disabled": u || void 0,
    "data-pressed": l || void 0,
    "data-selected": a || void 0,
    "data-hovered": b || void 0,
    "data-focus-visible": p || void 0
  });
}), mt = /* @__PURE__ */ X(null), wn = /* @__PURE__ */ X(null);
function Go(e) {
  let t = Tn(e), n = I(null), { triggerProps: r, tooltipProps: o } = Lo(e, t, n);
  return /* @__PURE__ */ S.createElement($r, {
    values: [
      [
        mt,
        t
      ],
      [
        wn,
        {
          ...o,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ S.createElement(Vr, {
    ...r,
    ref: n
  }, e.children));
}
const Yo = /* @__PURE__ */ we(function({ UNSTABLE_portalContainer: t, ...n }, r) {
  [n, r] = Le(n, r, wn);
  let o = W(mt), i = Tn(n), l = n.isOpen != null || n.defaultOpen != null || !o ? i : o, a = fr(r, l.isOpen) || n.isExiting || !1;
  return !l.isOpen && !a ? null : /* @__PURE__ */ S.createElement(wo, {
    portalContainer: t
  }, /* @__PURE__ */ S.createElement(Ko, {
    ...n,
    tooltipRef: r,
    isExiting: a
  }));
});
function Ko(e) {
  let t = W(mt), n = I(null), [r, o] = G(0);
  q(() => {
    n.current && t.isOpen && o(n.current.getBoundingClientRect().width);
  }, [
    t.isOpen,
    n
  ]);
  let { overlayProps: i, arrowProps: l, placement: a } = bo({
    placement: e.placement || "top",
    targetRef: e.triggerRef,
    overlayRef: e.tooltipRef,
    offset: e.offset,
    crossOffset: e.crossOffset,
    isOpen: t.isOpen,
    arrowSize: r,
    arrowBoundaryOffset: e.arrowBoundaryOffset,
    shouldFlip: e.shouldFlip,
    onClose: () => t.close(!0)
  }), u = dr(e.tooltipRef, !!a) || e.isEntering || !1, d = Se({
    ...e,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: a,
      isEntering: u,
      isExiting: e.isExiting,
      state: t
    }
  });
  e = V(e, i);
  let { tooltipProps: f } = So(e, t);
  return /* @__PURE__ */ S.createElement("div", {
    ...f,
    ref: e.tooltipRef,
    ...d,
    style: {
      ...i.style,
      ...d.style
    },
    "data-placement": a ?? void 0,
    "data-entering": u || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ S.createElement(Ao.Provider, {
    value: {
      ...l,
      placement: a,
      ref: n
    }
  }, d.children));
}
export {
  jo as $,
  Wo as a,
  Uo as b,
  On as c,
  Bo as d,
  Go as e,
  Yo as f
};
//# sourceMappingURL=vendor-CwFtm_qv.js.map
